import React, {Fragment, useContext} from "react";
import { useLocation } from "react-router";
import AuthenticationService from "../../services/AuthenticationService";
import {Link, Redirect, useHistory} from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import { ChevronUpDownIcon } from "@heroicons/react/24/solid";

import getRoutePath from "../../routes/getRoutePath";
import CountryContext from "../../CountryContext";
import {FormattedMessage, useIntl} from "react-intl";
import MenuIcon from "@ui-components/AppNavigation/MenuIcon";
import MenuLink from "@ui-components/AppNavigation/MenuLink";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const UserBox = ({
  slim = false,
  slimDropdownOpen = undefined,
  toggleSlimDropdown = undefined,
  closeSlimDropdown = undefined,
}) => {
  const intl = useIntl();
  const userData = AuthenticationService.getUserData();
  const { pathname } = useLocation();
  const { country } = useContext(CountryContext);
  const { firstname, lastname, role_type, account_user_role_type } = userData ?? {};
  const history = useHistory();

  // if user's access token has expired, don't try to render anything (they will be redirected to login page anyway, but
  // at least no errors will be thrown before the redirect happens)
  if (!userData)
    return (
      <Redirect
        to={{ pathname: `/${country.code}`, state: { from: pathname } }}
      />
    );

  const items = [
    {
      name: "profile",
      href: "/profile",
      onClick: () => {},
    },
    {
      name: "logout",
      href: "/logout",
      onClick: (e) => {
        e.preventDefault();
        AuthenticationService.logout();
        history.push(getRoutePath("/login"));
      }
    }
  ]

  if (slim)
    return (
      <MenuLink
        name="User"
        href={undefined}
        Icon={({}) => <MenuIcon name="User" />}
        initialUrl={undefined}
        externalHref={undefined}
        dropdown={items}
        notificationsCount={undefined}
        slim={true}
        inner={false}
        last={false}
        isDropdownOpen={slimDropdownOpen}
        toggleDropdown={toggleSlimDropdown}
        closeDropdown={closeSlimDropdown}
      />
    )

  return (
    <Menu as="div" className="mb-2 mt-3 relative inline-block text-left w-full">
      <div>
        <Menu.Button className="group w-full bg-black-500 pl-3 pr-2 py-2 text-sm text-left font-medium text-gray-700 hover:bg-am-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-am-500">
          <span className="flex w-full justify-between items-center">
            <span className="flex min-w-0 items-center justify-between space-x-2">
              <span className="flex-1 flex flex-col min-w-0">
                <span className="text-white text-sm font-semibold truncate leading-none pb-1">
                  {firstname} {lastname}
                </span>
                <span className="text-white text-xs truncate capitalize leading-none pb-1">
                  {intl.formatMessage({ id: "user_type_" + (account_user_role_type ?? role_type) })}
                </span>
              </span>
            </span>
            <ChevronUpDownIcon
              className="flex-shrink-0 h-5 w-5 text-white"
              aria-hidden="true"
            />
          </span>
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items
          id="menu"
          className="z-10 origin-top absolute right-0 left-0 mt-1 shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-200 focus:outline-none"
        >
          <div className="py-1">
            {
              items.map((item, idx) => (
                <Menu.Item key={idx}>
                  {({ active }) => (
                    <Link
                      to={`/${country.code}${item.href}`}
                      className={classNames(
                        active ? "bg-ivory text-black-500" : "text-black-500",
                        "block px-4 py-2 text-sm",
                      )}
                      onClick={item.onClick}
                    >
                      <FormattedMessage id={item.name} />
                    </Link>
                  )}
                </Menu.Item>
              ))
            }
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default UserBox;
